<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-9">
                <b-card>
                    <div slot="header">
                        <i class="fa fa-unlock"></i><strong> Account</strong>
                        <small>activeren</small>
                    </div>
                    <form @submit.prevent="saveItem" autocomplete="off">
                        <input autocomplete="off" name="hidden" type="text" style="display:none;">
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="table table-bordered table-striped table-sm">
                                <tbody>
                                <tr>
                                    <th>Naam: </th><td>{{model.voornaam + ' '+ model.naam}}</td>
                                </tr>
                                <tr>
                                    <th>E-mail: </th><td>{{model.email}}</td>
                                </tr>
                                <tr>
                                    <th>Type: </th><td>{{model.typeuser.naam}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="wachtwoord">Nieuw wachtwoord (automatisch ingesteld na activeren van de account)<sup>*</sup></label>
                                <input type="text" v-model="model.password" id="wachtwoord" name="wachtwoord" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('wachtwoord') }" />
                                <span class="small text-danger" v-show="errors.has('wachtwoord')">Wachtwoord is verplicht</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="wachtwoord">&nbsp;</label><br />
                                <label class="switch switch-text switch-primary">
                                    <input type="checkbox" class="switch-input" :checked="model.sendmail" @change="handleChange">
                                    <span class="switch-label" data-on="ON" data-off="OFF"></span>
                                    <span class="switch-handle"></span>
                                </label>
                                &nbsp;&nbsp;Mail versturen met wachtwoord
                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label">Actief van <sup>*</sup></label>
                                <input type="date" class="unstyled" v-model="model.begindatum" name="begindatum" id="begindatum" ref="begindatum" />
                                <span v-show="!model.begindatum" class="small text-danger">Kies een begindatum</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label">tot <sup>*</sup></label>
                                <input type="date" class="unstyled" v-model="model.einddatum" name="einddatum" id="einddatum" ref="einddatum" />
                                <span v-show="!model.einddatum" class="small text-danger">Kies een einddatum</span>
                            </div>
                        </div>
                    </div>
                    <div slot="footer">
                        <b-button type="submit" variant="primary">
                            Activeren
                        </b-button>
                        <b-button type="button" @click="back" variant="secondary">Annuleren</b-button>
                    </div>
                    </form>
                </b-card>
            </div>
        </div>
        <div style="height: 17em"></div>
    </div>
</template>

<script>

    export default {
        name: 'Form',
        props: ['model'],
        data () {
            return {
                isError: false,
            };
        },
        methods: {
            handleChange()  {
                this.model.sendmail = !this.model.sendmail;
            },
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$emit('activate', this.model);
                    }
                });
            },
            back () {
                this.$router.go(-1);
            },
        },
        components: {
        },
    };
</script>

<style>

    input, select {
        padding: .55em .5em;
        font-size: 100%;
        border: 1px solid #ccc;
        width: 100%
    }

    .unstyled::-webkit-outer-spin-button, /* Removes arrows */
    .unstyled::-webkit-inner-spin-button, /* Removes arrows */
    .unstyled::-webkit-clear-button { /* Removes blue cross */
      -webkit-appearance: none;
      margin: 0;
    }

</style>



// WEBPACK FOOTER //
// src/pages/account/MailForm.vue